import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'
import { useHelpCenter } from '@/HelpCenter/ui/context/HelpCenterContext'
import {
    OreRadioButton,
    OreStack,
    OreText
} from '@edenredespana/oreneta'

export const NewTicketStep3 = (): JSX.Element => {
    const { t } = useTranslation()
    const {
        caseProducts,
        getCaseProducts,
        form } = useHelpCenter()
    const selectedProductId = form.watch('caseProductId')

    useEffect(() => {
        getCaseProducts()
    }, [])

    return (
        <OreStack space="medium" placeContent="stretch">
            <OreStack space="xsmall" placeContent="stretch">
                <OreText size="text-lg" bold>{t(HelpCenterTranslations.step3.title)}</OreText>
                <OreText>{t(HelpCenterTranslations.step3.subtitle)}</OreText>
            </OreStack>
            <OreStack space="small" placeContent="stretch">
                {caseProducts?.map((product) => (
                    <OreRadioButton
                        key={product.caseProductId}
                        label={product.productName}
                        name="caseProductId"
                        value={String(product.caseProductId)}
                        checked={selectedProductId === product.caseProductId}
                        onChange={() => form.setValue('caseProductId', product.caseProductId, { shouldValidate: true })}
                    />
                ))}
                {caseProducts.length > 0 && (
                    <OreRadioButton
                        key={-1}
                        label={t(HelpCenterTranslations.step3.noSpecificProduct)}
                        name="caseProductId"
                        value={String(-1)}
                        checked={selectedProductId === -1}
                        onChange={() => form.setValue('caseProductId', -1, { shouldValidate: true })}
                    />
                )}
            </OreStack>
        </OreStack>
    )
}


